import { FC, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Context } from '.'
import { useLocation, useParams } from 'react-router-dom'
import useWindowDimensions from './core/hooks/useWindowDimensions'
import AppRouter from './components/AppRouter'

import InputMask from 'react-input-mask'

import './styles/App.scss'
import Footer from './components/Footer'
import Header from './components/Header'
import { useFetching } from './core/hooks/useFetching'
import { ApiService } from './core/api/api'
import { getStudioDisplayImages } from './core/utils/studioImages'
import { getCountryCode, isNullOrUndefined, scrollPageToTop, shuffle, translit } from './core/utils/utils'
import OptionsModal from './pages/_shared/OptionsModal/OptionsModal'
import { StoreOrder } from './core/models/store/order'
import { YMaps } from '@pbe/react-yandex-maps'
import { Translation } from './core/models/Translate'
import { getTranslates, SNG_OR_WRLD, StorageKeys } from './core/utils/defaults'
import { IntlProvider } from 'react-intl'
import { LOCALES } from './core/i18n/locales'
import Modal from './components/Modal'
import { message } from 'antd'
import moment from 'moment'
import { usePhoneMask } from './pages/Account/hooks/usePhoneMask'
import { PhoneMaskSelectModal } from './pages/Account/components/PhoneMaskSelectModal'
import { SEOMeta } from './components/SEOMeta'
import { Icon } from './components/icons/Icon'
import iconStyles from './styles/Icon.module.scss'
import CookieConsent from './components/CookieConsent'

declare const ymaps: any

const App: FC = () => {
	const { store, shopStore, studioStore, adminStore } = useContext(Context)

	const location = useLocation()
	const params: any = useParams()

	const { width, height } = useWindowDimensions()

	// const { coords, isGeolocationAvailable, isGeolocationEnabled } = useGeolocated({
	//   positionOptions: {
	//     enableHighAccuracy: false,
	//   },
	//   userDecisionTimeout: 5000,
	// })

	const coords = undefined as any | undefined
	const isGeolocationEnabled = false

	const [timeAdventure, setTimeAdventure] = useState(0)
	const [adventureVisible, setAdventureVisible] = useState(false)

	const [isPhoneCodeVisible, setIsPhoneCodeVisible] = useState(false)
	const [selectedPhoneCode, setSelectedPhoneCode] = useState('7')
	const [preSelectedPhoneCode, setPreSelectedPhoneCode] = useState('7')
	const [selectedPhoneMask, setSelectedPhoneMask] = useState('999 999 99 99')
	const [preSelectedPhoneMask, setPreSelectedPhoneMask] = useState('999 999 99 99')

	const [userName, setUserName] = useState('')
	const [userPhone, setUserPhone] = useState('')
	const [userEmail, setUserEmail] = useState('')
	const [userTask, setUserTask] = useState('')

	const [phonePlaceholder, setPhonePlaceholder] = useState('')

	useLayoutEffect(() => {
		scrollPageToTop()
	}, [location.pathname])

	const [fetchSettings] = useFetching(async () => {
		const res = await ApiService.core.getSettings()

		let techworks = res.data.settings.find((v: any) => v.name == 'techworks')
		let tr = res.data.settings.find((v: any) => v.name == 'translations')

		if (techworks != undefined) {
			store.setTechworksState(techworks.data.state)
			store.setTechworksSetting(techworks)
		}

		let lst: any = {},
			lst2: any[] = [],
			lst3: any[] = []
		tr.data.forEach((lang: Translation) => {
			let ccode = getCountryCode(lang.nameEn)
			lst2.push({ name: lang.name, nameEn: lang.nameEn, code: ccode })

			lst[ccode] = {}
			lang.items.forEach((item) => {
				if (ccode == 'ru-RU') {
					lst[ccode][item.name] = item.value
				} else {
					if (!isNullOrUndefined(item.value_en)) {
						lst[ccode][item.name] = item.value_en
					} else {
						lst[ccode][item.name] = item.value
					}
				}
			})

			lst3.push({ ...lang })
		})

		const restoreLocale = localStorage.getItem(StorageKeys.LOCALE)
		if (restoreLocale != null) {
			store.setLocale(restoreLocale)
		} else {
			store.setLocale(lst2[0].code)
			localStorage.setItem(StorageKeys.LOCALE, lst2[0].code)
		}

		const { locales, translations } = getTranslates()

		store.setTransAll(lst3)
		store.setTranslations(translations)
		store.setLocales(locales)

		let domain = window.location.hostname

		if (domain.includes('.com')) {
			store.setLocale(LOCALES.ENGLISH)
		}

		store.setIsSettingsPreloaded(true)
		setTimeout(() => {
			store.setIsSettingsLoaded(true)
		}, 100)
	})

	const adventureTimeStorage = ({ res }: { res?: any }) => {
		let adventureTime = 0
		let restoreTicket = localStorage.getItem('x_adventure_time_ticket')
		if (restoreTicket != null) {
			let now = moment().unix() - 43200
			let rest = parseInt(restoreTicket)
			if (now > rest) {
				localStorage.setItem('x_adventure_time', '0')
				localStorage.removeItem('x_adventure_time_ticket')
				fetchAccount()
			}
		} else {
			if (!res || (res.data.user.role !== 'ADMIN' && res.data.user.role !== 'PARTNER')) {
				let inter = setInterval(() => {
					adventureTime += 3
					localStorage.setItem('x_adventure_time', `${adventureTime}`)

					if (adventureTime >= 100 && studioStore.orders.filter((v) => v.status == 0 || v.status == 1).length == 0) {
						setAdventureVisible(true)
						clearInterval(inter)
					}
				}, 3000)
			}
		}
	}

	const [fetchAccount] = useFetching(async () => {
		if (studioStore.isLoadingA) {
			return
		}

		let tokenExist = false
		studioStore.setIsLoadingA(true)

		const authed = await store.checkAuth()

		// if (!authed) {
		// 	const res = await ApiService.users.signInWithToken({ type: 'check' })

		// 	if (res.data.state == 2) tokenExist = true
		// }

		if (authed) {
			try {
				const res = await ApiService.users.getAccount()
				const resOrders = await ApiService.studios.getMyOrders()

				let ordrs: any[] = resOrders.data.orders.sort((a: StoreOrder, b: StoreOrder) => {
					return a.status > b.status ? 1 : a.status < b.status ? -1 : 0
				})
				studioStore.setOrders(ordrs)

				let active = ordrs.filter((v) => v.status == 0 || v.status == 1)

				if (active.length == 0) {
					adventureTimeStorage({ res })
				}

				if (res.data.state == 1) {
					store.setupAuth(res.data.user.token, res.data.user)
				}
			} catch (err) {}
		} else {
			adventureTimeStorage({})
		}

		studioStore.setIsLoadingA(false)
	})

	const [fetchCountries] = useFetching(async () => {
		const res = await ApiService.studios.getCountries()

		let ctrs: any[] = res.data.countries.sort((a: any, b: any) => {
			return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
		})

		// if (SNG_OR_WRLD == "sng") {
		//   ctrs = ctrs.filter(v => v.is_sng == true)
		// } else {
		//   ctrs = ctrs.filter(v => v.is_sng == false)
		// }

		studioStore.setCountries(ctrs)

		const restoreCtr = localStorage.getItem(StorageKeys.COUNTRY)
		if (restoreCtr != null) {
			studioStore.setSelCountry(JSON.parse(restoreCtr))
		} else {
			studioStore.setSelCountry(ctrs[0])
		}

		let domain = window.location.hostname
		let fnded = ctrs.findIndex((v) => v.domain == domain)
		if (fnded != -1) {
			studioStore.setSelCountry(ctrs[fnded])
		}

		fetchCities()
	})

	const [fetchCities] = useFetching(async () => {
		const citiesRes = await ApiService.studios.getCities()

		let cities: any[] = citiesRes.data.cities.sort((a: any, b: any) => {
			return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
		})

		studioStore.setAllCities([...cities])

		if (studioStore.selCountry != null) {
			cities = cities.filter((v) => v.country_id == studioStore.selCountry.id)
		}

		cities = cities.map((v) => {
			return { ...v, code: translit(v.name.toLowerCase()) }
		})

		let cts: any[] = cities.map((v) => {
			return { code: translit(v.name.toLowerCase()), name: v.name, id: v.id }
		})

		studioStore.setCities(cities)

		if (studioStore.selectedCity == null) {
				if (isNullOrUndefined(params.city)) {
					const ymapsGlobal = (globalThis as any).ymaps
					if (isGeolocationEnabled && coords != undefined && ymapsGlobal?.geocode) {
						const geocoder = ymapsGlobal.geocode([coords.latitude, coords.longitude])

					geocoder.then(
						(res: any) => {
							const cityChilds = res.geoObjects._collectionComponent._baseArrayComponent._children

							if (!isNullOrUndefined(cityChilds) && cityChilds.length > 0) {
								const cityContain = cityChilds[0].properties._data.text
								let exists: any | null = null
								cities.forEach((city) => {
									if (cityContain.toLowerCase().includes(city.name.toLowerCase())) {
										exists = city
									}
								})

								if (exists !== null) {
									studioStore.setSelectedCity(exists)
									studioStore.setSelectedCityName(exists.name)
								}

								// if (exists == null) {
								//   studioStore.setSelectedCity(cities[0])
								//   studioStore.setSelectedCityName(cities[0].name)
								// } else {
								//   studioStore.setSelectedCity(exists)
								//   studioStore.setSelectedCityName(exists.name)
								// }
							}
						},
						(err: any) => {}
					)
				} else {
					// studioStore.setSelectedCity(cities[0])
					// studioStore.setSelectedCityName(cities[0].name)
				}
			} else {
				const exCity = cities.find((v) => v.code == params.city)
				if (exCity != undefined) {
					// studioStore.setSelectedCityName(exCity.name)
					// studioStore.setSelectedCity(exCity)
				}
			}
		}
	})

	// country_id=1&city_id=0&page=1&limit=30&search=&category=all&order=DESC&order_by=id&status=1&date=&time=&service=&sort=default&metro=&facils=&servs=
	// country_id=1&city_id=0&page=1&limit=30&search=&category=all&order=DESC&order_by=id&status=all&date=&time=&service=&sort=default&metro=&facils=&servs=

	const [fetchStudios] = useFetching(async () => {
		if (studioStore.isLoadingD) {
			return
		}

		studioStore.setIsLoadingD(true)

		const res = await ApiService.studios.getStudios({
			country_id: studioStore.selCountry == null ? 1 : studioStore.selCountry.id,
			city_id: studioStore.selectedCity == null ? 0 : studioStore.selectedCity.id,
			page: studioStore.pageIndex,
			limit: studioStore.pageLimit,
			search: studioStore.search,
			searchFilter: '',
			category: studioStore.category,
			order: studioStore.order,
			order_by: studioStore.orderBy,
			status: '1',
			date: studioStore.searchDate,
			time: studioStore.searchTime,
			service: studioStore.searchService,
			sort: studioStore.selectedSort,
			metro: studioStore.metro,
			facils: studioStore.selectedFacils.map((v) => v.name).join(';'),
			servs: studioStore.selectedServs.map((v) => v.name).join(';'),
		})

		let studiosLst: any[] = res.data.studios

		let top_priority: any[] = studiosLst.filter((v) => v.top_priority != 0)
		let unfilled: any[] = studiosLst.filter((v) => v.images == '' || v.phone == '' || v.address == '')
		let all: any[] = studiosLst.filter((v) => v.top_priority == 0 && v.images != '' && v.phone != '' && v.address != '')

		all = shuffle(all)
		all = shuffle(all)

		studiosLst = [...top_priority, ...all, ...unfilled]

		studiosLst = studiosLst.map((v) => {
			let city = studioStore.cities.find((ct) => ct.id == v.city_id)
			const imgs = getStudioDisplayImages(v.images, v.tariff)
			return { ...v, city, imgs, sel_image: imgs[0] ?? '' }
		})

		studioStore.setTotalStudios(res.data.total)
		studioStore.setStudios(studiosLst)
		studioStore.setIsLoadingD(false)
	})

	const [fetchCats] = useFetching(async () => {
		const res = await ApiService.studios.getCats()
		let cts: any[] = res.data.cats

		cts = cts.sort((a: any, b: any) => {
			return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
		})

		studioStore.setAllCats(cts)
	})

	const [fetchStocks] = useFetching(async () => {
		const res = await ApiService.studios.getStocks()
		let cts: any[] = res.data.stocks

		cts = cts.sort((a: any, b: any) => {
			return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
		})

		studioStore.setAllStocks(cts)
	})

	const [fetchHashtags] = useFetching(async () => {
		const res = await ApiService.studios.getHashtags(Number(studioStore.selCountry?.id) || 0)
		let cts: any[] = res.data.hashtags

		// Перемешиваем массив случайным образом
		const shuffled = [...cts].sort(() => Math.random() - 0.5)

		studioStore.setAllHashtags(shuffled)
	})

	const handleLeftPosition = () => {
		const cardwrap = document.getElementById('cardwrap')

		if (cardwrap != null) {
			if (width > 960) {
				shopStore.setLeftPos(`${cardwrap.offsetLeft - 1}px`)
			} else if (width > 768) {
				shopStore.setLeftPos(`${cardwrap.clientWidth / 2 - 190}px`)
			} else {
				shopStore.setLeftPos(``)
			}
		}
	}

	const sendAdventureTask = async () => {
		if (userName == '') {
			return message.warning('Введите ваше имя')
		}

		if (userPhone == '' || userPhone.includes('_')) {
			return message.warning('Введите ваш номер телефона')
		}

		if (userEmail == '') {
			return message.warning('Введите ваш email')
		}

		if (userTask == '') {
			return message.warning('Введите описание вашей задачи')
		}

		const res = await ApiService.users.sendAdventureTask({
			name: userName,
			email: userEmail,
			task: userTask,
			phone: userPhone,
			user_id: store.isAuth ? store.userData.id : 0,
		})

		if (res.data.state == 0) {
			return message.error(res.data.message)
		}

		message.success('Ваша заявка успешно отправлена!')
		setAdventureVisible(false)
		localStorage.setItem('x_adventure_time_ticket', `${moment().unix()}`)
	}

	useEffect(() => {
		handleLeftPosition()
	}, [width])

	useEffect(() => {
		if (width <= 768) {
			store.setIsMobile(true)
		} else {
			store.setIsMobile(false)
		}
	}, [width, height])

	useEffect(() => {
		if (width <= 768) {
			store.setIsMobile(true)
		} else {
			store.setIsMobile(false)
		}

		handleLeftPosition()

		setTimeout(() => {
			handleLeftPosition()
		}, 1000)

		fetchCountries()

		fetchCats()
		fetchStocks()
		fetchHashtags()
		fetchSettings()
		fetchAccount()
		fetchStudios()
	}, [])

	const phoneMaskHook = usePhoneMask({
		phoneCode: studioStore?.selCountry?.phone_code ?? '7',
		phoneMask: studioStore?.selCountry?.phone_mask ?? '999 999 99 99',
		countryEN: studioStore?.selCountry?.name_en ?? 'Russia',
	})

	useEffect(() => {
		if (studioStore?.selCountry?.id) {
			fetchHashtags()
			phoneMaskHook.selectCountry({
				phone_code: studioStore.selCountry.phone_code,
				phone_mask: studioStore.selCountry.phone_mask,
				name_en: studioStore.selCountry.name_en,
			})
			phoneMaskHook.applySelection()
			phoneMaskHook.reset()
			setPhonePlaceholder(studioStore.selCountry.phone_mask)
		}
	}, [studioStore?.selCountry?.id])

	useEffect(() => {
		if (phoneMaskHook?.phoneMask) {
			setPhonePlaceholder(phoneMaskHook.phoneMask)
		}
	}, [phoneMaskHook?.phoneMask])

	return (
		<>
			<SEOMeta />
			<div className='xfader' style={{ opacity: store.isSettingsLoaded ? '1' : '0' }}>
				{store.isSettingsPreloaded ? (
					<>
						{store.techworksState &&
						!location.pathname.includes('admin') &&
						(!store.isAuth || (store.isAuth && store.userData.role != 'ADMIN')) ? (
							<>
								<div className={'placeholder'}>
									<div className={'ph_wrap'}>{/* TODO: Технические работы на сайте */}</div>
								</div>
							</>
						) : location.pathname.includes('/admin') ||
						  location.pathname.includes('/timetable') ||
						  location.pathname.includes('/booking') ? (
							<>
								<IntlProvider
									messages={store.translations[store.locale]}
									locale={store.locale}
									defaultLocale={LOCALES.RUSSIAN}
								>
									<AppRouter />
								</IntlProvider>
							</>
						) : (
							<>
								<IntlProvider
									messages={store.translations[store.locale]}
									locale={store.locale}
									defaultLocale={LOCALES.RUSSIAN}
								>
									<YMaps query={{ lang: 'ru_RU', apikey: 'ddba014a-2dcd-4f60-9c58-4bd8d9d0c0e4' }}>
										<Header />
										<AppRouter />
										<Footer />
									</YMaps>

									<OptionsModal
										height='auto'
										openned={studioStore.isCityVisible}
										title={store.locale == LOCALES.RUSSIAN ? 'Выберите город' : 'Select a city'}
										onClose={() => studioStore.setIsCityVisible(false)}
										done={store.locale == LOCALES.RUSSIAN ? 'Выбрать' : 'Select'}
										onDone={() => {
											studioStore.setIsCityVisible(false)
										}}
									>
										<div className='cities_selecting'>
											{studioStore.cities.map((city) => (
												<div
													key={city.id}
													className={'cs_item' + (studioStore.selectedCityName == city.name ? ' selected' : '')}
													onClick={() => {
														studioStore.setSelectedCity(city)
														studioStore.setSelectedCityName(city.name)
													}}
												>
													<div className='cs_item__name'>
														{store.locale == LOCALES.RUSSIAN ? city.name : city.name_en || city.name}
													</div>
													<div className='cs_item__check'>
														<span>
															<Icon variant={'check'} className={iconStyles.city_check} />
														</span>
													</div>
												</div>
											))}
										</div>
									</OptionsModal>

									<Modal
										// visible={adventureVisible}
										visible={false}
										onClose={() => {
											setAdventureVisible(false)
											localStorage.setItem('x_adventure_time_ticket', `${moment().unix()}`)
										}}
										title='Не нашли подходящую студию?'
										content={
											<>
												<div className='modal_text'>
													<p>
														Если вы не нашли подходящую студию, можете отправить заявку, наш менеджер свяжется с вами и
														поможет подобрать идеальный вариант
													</p>

													<div className='xform'>
														<div className='xfield'>
															<label htmlFor='name'>Ваше имя</label>
															<input
																type='text'
																placeholder='Иван Иванов'
																value={userName}
																onChange={(ev) => setUserName(ev.target.value)}
															/>
														</div>
														<div className='xflexed'>
															<div className='xfield'>
																<label htmlFor='name'>Ваш телефон</label>
																<div className={'xfield_input' + ' ' + 'countried'}>
																	<div
																		className={'country_sel'}
																		onClick={() => {
																			phoneMaskHook.openModal()
																		}}
																	>
																		+{phoneMaskHook.phoneCode}
																	</div>
																	<InputMask
																		key={phoneMaskHook.phoneMask}
																		mask={phoneMaskHook.phoneMask}
																		maskChar='_'
																		placeholder={phonePlaceholder}
																		value={userPhone}
																		onChange={(event) => setUserPhone(event.target.value)}
																	/>
																</div>
															</div>
															<div className='xfield'>
																<label htmlFor='name'>Ваш email</label>
																<input
																	type='text'
																	placeholder='example@gmail.com'
																	value={userEmail}
																	onChange={(ev) => setUserEmail(ev.target.value)}
																/>
															</div>
														</div>
														<div className='xfield'>
															<label htmlFor='name'>Описание задачи</label>
															<textarea
																rows={5}
																placeholder='Ищу студию звукозаписи с определенным оборудованием...'
																value={userTask}
																onChange={(ev) => setUserTask(ev.target.value)}
															></textarea>
														</div>
													</div>
												</div>
												<div className='modal_action'>
													<div>
														<button onClick={() => sendAdventureTask()}>Отправить</button>
													</div>
												</div>
											</>
										}
									/>

									<PhoneMaskSelectModal
										phoneMaskHook={phoneMaskHook}
										phoneCodeUpdated={phoneMaskHook.phoneCode}
										onSelectionChange={(data) => {}}
									/>
								</IntlProvider>
							</>
						)}
					</>
				) : (
					<></>
				)}
			</div>
			{store.isSettingsLoaded && <CookieConsent />}
		</>
	)
}

export default observer(App)
